var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { on: { click: _vm.emitShowConsistencyAnalysis } },
    [
      _vm.status === "Unknown"
        ? [
            _c(
              "span",
              {
                staticClass: "fa-stack fa-lg",
                attrs: { title: "Insufficient data to check consistency" },
              },
              [
                _c("i", {
                  staticClass: "fa fa-circle text-light",
                  class: `fa-stack-${_vm.size}x`,
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa-regular fa-circle",
                  class: `fa-stack-${_vm.size}x`,
                }),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.status === "Inconsistent"
        ? [
            _c(
              "span",
              {
                staticClass: "fa-stack fa-lg",
                attrs: { title: "Inconsistencies detected" },
              },
              [
                _c("i", {
                  staticClass: "fa fa-circle text-danger",
                  class: `fa-stack-${_vm.size}x`,
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa-regular fa-face-frown",
                  class: `fa-stack-${_vm.size}x`,
                }),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.status === "Acceptable"
        ? [
            _c("span", { staticClass: "fa-stack fa-lg" }, [
              _c("i", {
                staticClass: "fa fa-circle text-warning",
                class: `fa-stack-${_vm.size}x`,
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa-regular fa-face-meh",
                class: `fa-stack-${_vm.size}x`,
              }),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.status === "Consistent"
        ? [
            _c("span", { staticClass: "fa-stack fa-lg" }, [
              _c("i", {
                staticClass: "fa fa-circle text-success",
                class: `fa-stack-${_vm.size}x`,
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa-regular fa-face-smile",
                class: `fa-stack-${_vm.size}x`,
              }),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }